import axios from 'axios'
import router from '@/router';
const needVerifyList = [
	'/api/u-portal/auth/logout',
	'/api/u-portal/auth/user',
  '/api/u-portal/auth/reset-pwd',
  '/api/u-portal/auth/user/edit',
  '/api/u-portal/auth/pay-mem-fee',  
	'/api/u-portal/msg/',
	'/api/u-portal/cbt/',
  '/api/u-portal/mem/',
  '/api/u-portal/act/',
  '/api/u-portal/apply/invoice/'
];

export default function fetch(url, options = {}) {
  const token = localStorage.getItem('token') || '';
  const method = options.method || 'GET';
	const urlNeedVerify = needVerifyList.findIndex(u => url.startsWith(u)) !== -1;
  const params = {
    url,
    method,
    headers: {
      'token': urlNeedVerify ? token : '',
      'Content-Type': 'application/json'
    },
  };
  if (method === 'GET') {
    params.params = options.data || {};
  } else {
    params.data = options.data || {};
  }
  return new Promise((resolve, reject) => {
    axios(params).then(res => {
      if (res.status === 200) {
        if (res.data.code === 200) {
          resolve(res.data.data);
        } else if (res.data.code === 601) {
          localStorage.removeItem('token');
          router.replace('/login');
        } else {
          reject(res.data.msg);
        }
      }
    }).catch(err => {
      reject(err);
    });
  })
}
